import {
  CV_JOBS_FETCH_STORAGE_STATUS,
  CV_JOBS_FETCH_STORAGE_STATUS_SUCCESS,
  CV_JOBS_FETCH_STORAGE_STATUS_ERROR,
  CV_JOBS_FETCH_PREVIEW,
  CV_JOBS_FETCH_PREVIEW_SUCCESS,
  CV_JOBS_FETCH_PREVIEW_ERROR,
  CV_JOBS_START_BULK,
  CV_JOBS_START_BULK_SUCCESS,
  CV_JOBS_START_BULK_ERROR,
  CV_JOBS_UPDATE_PROGRESS,
  CV_JOBS_COMPLETE,
  CV_JOBS_RESET,
} from '../actions/cvJobs'

const initialState = {
  // Storage status
  storageConfigured: false,
  storageType: null,
  isLoadingStorageStatus: false,
  storageStatusError: null,

  // Preview
  preview: null,
  isLoadingPreview: false,
  previewError: null,

  // Job
  currentJob: null,
  isStartingJob: false,
  startJobError: null,
  
  // Progress
  progress: null,
  isComplete: false,
}

export default function cvJobsReducer(state = initialState, action) {
  switch (action.type) {
    case CV_JOBS_FETCH_STORAGE_STATUS:
      return { ...state, isLoadingStorageStatus: true, storageStatusError: null }
    case CV_JOBS_FETCH_STORAGE_STATUS_SUCCESS:
      return {
        ...state,
        isLoadingStorageStatus: false,
        storageConfigured: action.payload.configured,
        storageType: action.payload.type,
      }
    case CV_JOBS_FETCH_STORAGE_STATUS_ERROR:
      return { ...state, isLoadingStorageStatus: false, storageStatusError: action.payload }

    case CV_JOBS_FETCH_PREVIEW:
      return { ...state, isLoadingPreview: true, previewError: null, preview: null }
    case CV_JOBS_FETCH_PREVIEW_SUCCESS:
      return { ...state, isLoadingPreview: false, preview: action.payload }
    case CV_JOBS_FETCH_PREVIEW_ERROR:
      return { ...state, isLoadingPreview: false, previewError: action.payload }

    case CV_JOBS_START_BULK:
      return { ...state, isStartingJob: true, startJobError: null, isComplete: false }
    case CV_JOBS_START_BULK_SUCCESS:
      return { ...state, isStartingJob: false, currentJob: action.payload, progress: action.payload }
    case CV_JOBS_START_BULK_ERROR:
      return { ...state, isStartingJob: false, startJobError: action.payload }

    case CV_JOBS_UPDATE_PROGRESS:
      return { ...state, progress: action.payload }
    case CV_JOBS_COMPLETE:
      return { ...state, progress: action.payload, isComplete: true }

    case CV_JOBS_RESET:
      return initialState

    default:
      return state
  }
}
